import React from 'react';
import { Box, Heading, BoxProps } from '@chakra-ui/react';

export const Section: React.FC<BoxProps & { title: string }> = ({
    title,
    children,
    ...rest
}) => {
    return (
        <Box {...rest}>
            <Heading fontSize="lg" paddingY="4">
                {title}
            </Heading>
            {children}
        </Box>
    );
};
